// All 21 New Jersey counties — used for statewide local-SEO landing pages.
// Each entry has unique, locally relevant copy to avoid thin/duplicate content.

export const REGIONS = ["North Jersey", "Central Jersey", "South Jersey & the Shore"];

export const COUNTIES = [
  {
    slug: "atlantic-county",
    name: "Atlantic",
    seat: "Mays Landing",
    region: "South Jersey & the Shore",
    cities: ["Atlantic City", "Egg Harbor Township", "Galloway", "Hammonton", "Pleasantville", "Absecon", "Ventnor City", "Margate City", "Somers Point", "Brigantine", "Northfield", "Mays Landing"],
    intro:
      "From Atlantic City's hospitality workforce to families in Galloway and Hammonton, Atlantic County residents juggle long shifts, seasonal schedules, and limited local availability. Online therapy brings licensed, in-network care to you — no Black Horse Pike drive required.",
    localNote:
      "Shift workers and seasonal employees can book early-evening and weekend sessions that fit around unpredictable hours.",
    neighbors: ["cape-may-county", "cumberland-county", "gloucester-county", "camden-county", "burlington-county", "ocean-county"],
  },
  {
    slug: "bergen-county",
    name: "Bergen",
    seat: "Hackensack",
    region: "North Jersey",
    cities: ["Hackensack", "Paramus", "Teaneck", "Fort Lee", "Englewood", "Ridgewood", "Fair Lawn", "Garfield", "Mahwah", "Ramsey", "Wyckoff", "Westwood", "Tenafly", "Cliffside Park", "Lodi", "Hasbrouck Heights"],
    intro:
      "Bergen County is New Jersey's most populous county — and one of its busiest. Between GWB commutes, competitive school districts, and Route 17 traffic, finding time for therapy can feel impossible. Virtual sessions let you get support from home or the office.",
    localNote:
      "Teens in high-pressure Bergen school districts often benefit from after-school online sessions that don't add another drive to the family calendar.",
    neighbors: ["passaic-county", "hudson-county", "essex-county"],
  },
  {
    slug: "burlington-county",
    name: "Burlington",
    seat: "Mount Holly",
    region: "South Jersey & the Shore",
    cities: ["Mount Laurel", "Moorestown", "Marlton (Evesham)", "Medford", "Cinnaminson", "Willingboro", "Burlington City", "Bordentown", "Delran", "Lumberton", "Mount Holly", "Pemberton"],
    intro:
      "Burlington County is New Jersey's largest county by land area, stretching from the Delaware River suburbs to the Pine Barrens, which puts local therapy out of reach for many. Online therapy gives Mount Laurel, Marlton, Medford, and military families near Joint Base McGuire-Dix-Lakehurst consistent, flexible care.",
    localNote:
      "Military and first-responder families appreciate virtual sessions that stay consistent through deployments, relocations, and shift changes.",
    neighbors: ["camden-county", "mercer-county", "monmouth-county", "ocean-county", "atlantic-county"],
  },
  {
    slug: "camden-county",
    name: "Camden",
    seat: "Camden",
    region: "South Jersey & the Shore",
    cities: ["Cherry Hill", "Camden", "Voorhees", "Haddonfield", "Collingswood", "Gloucester Township", "Pennsauken", "Haddon Township", "Winslow", "Lindenwold", "Berlin", "Audubon"],
    intro:
      "Whether you're in Cherry Hill, Haddonfield, Collingswood, or commuting to Philadelphia, Camden County life moves fast. Online therapy fits support into your week without adding Route 70 or I-295 traffic.",
    localNote:
      "Commuters into Philadelphia can schedule lunchtime or evening virtual sessions from a private office or home.",
    neighbors: ["burlington-county", "gloucester-county", "atlantic-county"],
  },
  {
    slug: "cape-may-county",
    name: "Cape May",
    seat: "Cape May Court House",
    region: "South Jersey & the Shore",
    cities: ["Cape May", "Ocean City", "Wildwood", "North Wildwood", "Sea Isle City", "Avalon", "Stone Harbor", "Lower Township", "Middle Township", "Upper Township", "Cape May Court House", "Villas"],
    intro:
      "In Cape May County, summer brings crowds and long workdays, while the off-season can bring isolation and fewer local resources. Virtual therapy gives Ocean City, Wildwood, and Cape May residents steady, year-round access to licensed care.",
    localNote:
      "Seasonal workers and small-business owners can keep therapy consistent through the busy summer and quiet winter months alike.",
    neighbors: ["atlantic-county", "cumberland-county"],
  },
  {
    slug: "cumberland-county",
    name: "Cumberland",
    seat: "Bridgeton",
    region: "South Jersey & the Shore",
    cities: ["Vineland", "Millville", "Bridgeton", "Upper Deerfield", "Commercial Township", "Fairfield", "Hopewell Township", "Downe Township", "Port Norris", "Rosenhayn"],
    intro:
      "Cumberland County's mix of farmland, small towns, and cities like Vineland and Millville means providers can be miles away — and waitlists long. Online therapy connects you with an in-network clinician without the drive.",
    localNote:
      "Rural families can access teen and child therapy from home, avoiding long trips after school or work.",
    neighbors: ["salem-county", "gloucester-county", "atlantic-county", "cape-may-county"],
  },
  {
    slug: "essex-county",
    name: "Essex",
    seat: "Newark",
    region: "North Jersey",
    cities: ["Newark", "Montclair", "West Orange", "Livingston", "Bloomfield", "East Orange", "Maplewood", "South Orange", "Millburn", "Short Hills", "Caldwell", "Verona", "Nutley", "Belleville", "Cedar Grove"],
    intro:
      "From downtown Newark to Montclair, Livingston, and Maplewood, Essex County residents balance demanding careers, NYC commutes, and full family lives. Online therapy offers the same quality care as an office — on your schedule.",
    localNote:
      "Professionals commuting by NJ Transit can book early-evening sessions and join from home without rushing across town.",
    neighbors: ["bergen-county", "passaic-county", "morris-county", "union-county", "hudson-county"],
  },
  {
    slug: "gloucester-county",
    name: "Gloucester",
    seat: "Woodbury",
    region: "South Jersey & the Shore",
    cities: ["Washington Township (Sewell)", "Deptford", "Glassboro", "Monroe Township", "Williamstown", "Mantua", "Mullica Hill", "Woodbury", "West Deptford", "Pitman", "Swedesboro", "Franklin Township"],
    intro:
      "Gloucester County is one of South Jersey's fastest-growing areas, with young families in Washington Township, Mullica Hill, and Swedesboro and a large student community at Rowan University. Virtual therapy fits between school, work, and family.",
    localNote:
      "College students and young adults can meet with a therapist from a dorm or apartment without needing a car.",
    neighbors: ["camden-county", "salem-county", "cumberland-county", "atlantic-county"],
  },
  {
    slug: "hudson-county",
    name: "Hudson",
    seat: "Jersey City",
    region: "North Jersey",
    cities: ["Jersey City", "Hoboken", "Bayonne", "Union City", "West New York", "North Bergen", "Weehawken", "Secaucus", "Kearny", "Harrison", "Guttenberg"],
    intro:
      "Hudson County is New Jersey's most densely populated county, home to fast-paced professionals in Jersey City and Hoboken and tight-knit communities in Bayonne and Union City. Online therapy fits packed schedules — all you need is a private corner and a screen.",
    localNote:
      "Remote and hybrid workers can book a session right before or after work — no PATH train, parking, or waiting room.",
    neighbors: ["bergen-county", "essex-county", "union-county"],
  },
  {
    slug: "hunterdon-county",
    name: "Hunterdon",
    seat: "Flemington",
    region: "Central Jersey",
    cities: ["Flemington", "Clinton", "Lambertville", "Readington", "Raritan Township", "Tewksbury", "Whitehouse Station", "High Bridge", "Lebanon", "Frenchtown", "Califon"],
    intro:
      "Hunterdon County's rolling farmland and small towns make it special — but also mean long drives to see a specialist. Online therapy brings licensed, in-network care to Flemington, Clinton, Lambertville, and every township in between.",
    localNote:
      "Families in rural townships can access specialized services like EMDR and teen therapy without a 30-minute drive each way.",
    neighbors: ["warren-county", "morris-county", "somerset-county", "mercer-county"],
  },
  {
    slug: "mercer-county",
    name: "Mercer",
    seat: "Trenton",
    region: "Central Jersey",
    cities: ["Princeton", "Trenton", "Hamilton", "Lawrenceville", "Ewing", "West Windsor", "Robbinsville", "Hopewell", "Pennington", "East Windsor", "Hightstown"],
    intro:
      "Home to Princeton, the State Capital in Trenton, and commuter towns like West Windsor and Hamilton, Mercer County blends academic, government, and corporate pressure. Online therapy offers a flexible, private way to manage stress and burnout.",
    localNote:
      "Students, academics, and state employees can schedule sessions around semesters, deadlines, and legislative calendars.",
    neighbors: ["hunterdon-county", "somerset-county", "middlesex-county", "monmouth-county", "burlington-county"],
  },
  {
    slug: "middlesex-county",
    name: "Middlesex",
    seat: "New Brunswick",
    region: "Central Jersey",
    cities: ["Edison", "Woodbridge", "New Brunswick", "Piscataway", "East Brunswick", "Old Bridge", "Sayreville", "Perth Amboy", "Monroe Township", "North Brunswick", "South Brunswick", "Metuchen", "Plainsboro"],
    intro:
      "Middlesex County sits at New Jersey's crossroads — the Turnpike, Route 1, and Route 18 all run through it. From Rutgers students in New Brunswick to families in Edison, Woodbridge, and Monroe, online therapy skips the traffic.",
    localNote:
      "Rutgers students and young professionals can connect from campus or home, with evening times that work around classes and jobs.",
    neighbors: ["union-county", "somerset-county", "mercer-county", "monmouth-county"],
  },
  {
    slug: "monmouth-county",
    name: "Monmouth",
    seat: "Freehold",
    region: "Central Jersey",
    cities: ["Freehold", "Red Bank", "Middletown", "Holmdel", "Marlboro", "Manalapan", "Long Branch", "Asbury Park", "Howell", "Wall Township", "Colts Neck", "Rumson", "Ocean Township", "Matawan"],
    intro:
      "From Red Bank and Asbury Park to Marlboro and Freehold, Monmouth County families balance shore-town living with Parkway commutes and ferry rides to Manhattan. Virtual therapy offers consistent support without another drive.",
    localNote:
      "Ferry and train commuters can schedule sessions from home in the evening, keeping therapy consistent year-round.",
    neighbors: ["middlesex-county", "mercer-county", "burlington-county", "ocean-county"],
  },
  {
    slug: "morris-county",
    name: "Morris",
    seat: "Morristown",
    region: "North Jersey",
    cities: ["Morristown", "Parsippany", "Montville", "Pine Brook", "Randolph", "Denville", "Rockaway", "Madison", "Chatham", "Florham Park", "Morris Plains", "Mount Olive", "Roxbury", "Boonton", "Mendham", "Kinnelon", "Whippany"],
    intro:
      "Morris County is home to our affiliated practice, Montville Therapy Group. NJ Therapy Online extends that care across Morristown, Parsippany, Randolph, Madison, and every Morris County town — no Route 10 or I-287 traffic required.",
    localNote:
      "Prefer to meet in person sometimes? In-person therapy is also available at our Montville, NJ location.",
    neighbors: ["sussex-county", "passaic-county", "essex-county", "union-county", "somerset-county", "hunterdon-county", "warren-county"],
  },
  {
    slug: "ocean-county",
    name: "Ocean",
    seat: "Toms River",
    region: "South Jersey & the Shore",
    cities: ["Toms River", "Lakewood", "Brick", "Jackson", "Manchester", "Point Pleasant", "Barnegat", "Manahawkin (Stafford)", "Forked River (Lacey)", "Little Egg Harbor", "Berkeley Township", "Long Beach Island", "Seaside Heights"],
    intro:
      "Ocean County stretches 40+ miles along the Shore, from Point Pleasant to Little Egg Harbor. With summer traffic on Route 9 and the Parkway, getting to an appointment can take longer than the session. Online therapy brings care home.",
    localNote:
      "Shore residents can keep therapy steady through busy summers, storms, and seasonal schedule changes.",
    neighbors: ["monmouth-county", "burlington-county", "atlantic-county"],
  },
  {
    slug: "passaic-county",
    name: "Passaic",
    seat: "Paterson",
    region: "North Jersey",
    cities: ["Paterson", "Clifton", "Passaic", "Wayne", "West Milford", "Little Falls", "Totowa", "Hawthorne", "Pompton Lakes", "Woodland Park", "Ringwood", "Haledon"],
    intro:
      "Passaic County spans the cities of Paterson, Clifton, and Passaic as well as the lakes and highlands of West Milford and Ringwood. Wherever you live, virtual therapy offers in-network support without the Route 23 or Route 46 drive.",
    localNote:
      "Residents in the northern highlands can access specialized services like EMDR and couples therapy without long winter drives.",
    neighbors: ["sussex-county", "morris-county", "essex-county", "bergen-county"],
  },
  {
    slug: "salem-county",
    name: "Salem",
    seat: "Salem",
    region: "South Jersey & the Shore",
    cities: ["Salem", "Pennsville", "Carneys Point", "Penns Grove", "Woodstown", "Pilesgrove", "Pittsgrove", "Elmer", "Alloway", "Quinton"],
    intro:
      "Salem County is New Jersey's least populous county, with beautiful farmland, small towns — and very few local therapists. Online therapy closes that gap for Pennsville, Woodstown, Carneys Point, and Salem residents.",
    localNote:
      "Families no longer need to drive to Delaware or Philadelphia for specialized child, teen, or trauma therapy.",
    neighbors: ["gloucester-county", "cumberland-county"],
  },
  {
    slug: "somerset-county",
    name: "Somerset",
    seat: "Somerville",
    region: "Central Jersey",
    cities: ["Bridgewater", "Somerville", "Hillsborough", "Franklin Township", "Basking Ridge", "Bernardsville", "Warren", "Bound Brook", "Branchburg", "Montgomery", "Raritan", "Watchung"],
    intro:
      "Somerset County's corporate corridors in Bridgewater and Warren and family towns like Hillsborough and Basking Ridge mean busy calendars. Online therapy makes it simple to prioritize your mental health without losing hours to I-78 or I-287.",
    localNote:
      "Working parents can book a midday virtual session from a home office and be back in time for school pickup.",
    neighbors: ["morris-county", "union-county", "middlesex-county", "mercer-county", "hunterdon-county"],
  },
  {
    slug: "sussex-county",
    name: "Sussex",
    seat: "Newton",
    region: "North Jersey",
    cities: ["Newton", "Sparta", "Vernon", "Hopatcong", "Franklin", "Hardyston", "Andover", "Byram", "Hamburg", "Stanhope", "Wantage", "Lafayette"],
    intro:
      "Sussex County's mountains, lakes, and open spaces are a big part of its appeal — but can make it hard to reach a therapist, especially in winter. Online therapy brings licensed care to Sparta, Vernon, Newton, Hopatcong, and beyond.",
    localNote:
      "No more cancelled sessions because of snow on Route 15 or Route 94 — therapy continues from home.",
    neighbors: ["warren-county", "morris-county", "passaic-county"],
  },
  {
    slug: "union-county",
    name: "Union",
    seat: "Elizabeth",
    region: "North Jersey",
    cities: ["Elizabeth", "Union", "Westfield", "Summit", "Cranford", "Linden", "Plainfield", "Rahway", "Scotch Plains", "New Providence", "Springfield", "Berkeley Heights", "Clark", "Roselle"],
    intro:
      "Union County packs a lot into a small area — cities like Elizabeth and Plainfield and suburbs like Westfield, Summit, and Cranford. Online therapy fits support into a busy week without Route 22 or Parkway traffic.",
    localNote:
      "Parents in Westfield, Summit, and Cranford can schedule teen sessions for after school, right from home.",
    neighbors: ["essex-county", "morris-county", "somerset-county", "middlesex-county"],
  },
  {
    slug: "warren-county",
    name: "Warren",
    seat: "Belvidere",
    region: "North Jersey",
    cities: ["Phillipsburg", "Hackettstown", "Washington", "Belvidere", "Blairstown", "Independence", "Lopatcong", "Allamuchy", "Hope", "Oxford", "Knowlton"],
    intro:
      "Warren County sits along the Delaware River in rural northwest New Jersey, where specialized care can be a long drive away. Virtual therapy gives Phillipsburg, Hackettstown, Washington, and Blairstown residents in-network support from home.",
    localNote:
      "Rural families can access child, teen, and couples therapy without long drives on Route 57 or I-80.",
    neighbors: ["sussex-county", "morris-county", "hunterdon-county"],
  },
];

export const getCounty = (slug) => COUNTIES.find((c) => c.slug === slug);
